module.exports = __webpack_public_path__ + "img/add.2b8a4989.svg";